export const SET_VERSION = 'SET_VERSION'

export const setVersion = (version: number) => {
  return {
    type: SET_VERSION,
    number: parseInt(`${version}`),
  }
}
